import React, { useState, useEffect } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { all_routes } from "../../../Router/all_routes";
import {
  ArrowLeft,
  ChevronUp,
  Edit,
} from "feather-icons-react/build/IconComponents";
import { useDispatch, useSelector } from "react-redux";
import { setToogleHeader } from "../../../core/redux/action";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import Swal from "sweetalert2";
import { api_get } from "../../../helpers/index";

const GroupTierDetail = () => {
  const route = all_routes;
  const dispatch = useDispatch();
  const data = useSelector((state) => state.toggle_header);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const groupTierId = searchParams.get("group_tier_id");

  // State for Group Tier details
  const [groupTierData, setGroupTierData] = useState(null);
  const [tierDetails, setTierDetails] = useState([]);

  const renderCollapseTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Collapse
    </Tooltip>
  );

  // Fetch the group tier details
  const fetchGroupTierDetails = async () => {
    try {
      const result = await api_get(`spinwheel/group_tier/get/${groupTierId}`);
      if (result.status) {
        setGroupTierData(result.data);
        // Fetch details for each tier in the group
        await fetchTierDetails(result.data.tier_id);
      }
    } catch (error) {
      console.error("Error fetching group tier details:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to fetch group tier details. Please try again later.",
      }).then(() => {
        navigate(route.groupTierList);
      });
    }
  };

  // Fetch details for each tier in the group
  const fetchTierDetails = async (tierIds) => {
    try {
      const tierDetailsPromises = tierIds.map(async (tierId) => {
        const result = await api_get(`spinwheel/tier/get/${tierId}`);
        if (result.status) {
          return result.data;
        }
        return null;
      });

      const details = await Promise.all(tierDetailsPromises);
      setTierDetails(details.filter(detail => detail !== null));
    } catch (error) {
      console.error("Error fetching tier details:", error);
    }
  };

  useEffect(() => {
    if (groupTierId) {
      fetchGroupTierDetails();
    }
  }, [groupTierId]);

  if (!groupTierData) {
    return (
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="page-title">
              <h4>Loading...</h4>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="page-title">
            <h4>Group Tier Details</h4>
            <h6>View group tier information</h6>
          </div>
          <ul className="table-top-head">
            <li>
              <div className="page-btn">
                <Link to={route.groupTierList} className="btn btn-secondary">
                  <ArrowLeft className="me-2" />
                  Back to Group Tier
                </Link>
              </div>
            </li>
            <li>
              <div className="page-btn">
                <Link to={`/edit-group-tier?group_tier_id=${groupTierId}`} className="btn btn-primary">
                  <Edit className="me-2" />
                  Edit Group Tier
                </Link>
              </div>
            </li>
            <li>
              <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>
                <Link
                  data-bs-toggle="tooltip"
                  id="collapse-header"
                  className={data ? "active" : ""}
                  onClick={() => {
                    dispatch(setToogleHeader(!data));
                  }}
                >
                  <ChevronUp className="feather-chevron-up" />
                </Link>
              </OverlayTrigger>
            </li>
          </ul>
        </div>

        <div className="row">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-body">
                <div className="prizedetails">
                  <ul className="product-bar">
                    <li>
                      <h4>Group Tier ID</h4>
                      <h6>{groupTierData.group_tier_id}</h6>
                    </li>
                    <li>
                      <h4>Group Tier Name</h4>
                      <h6>{groupTierData.name}</h6>
                    </li>
                    <li>
                      <h4>Description</h4>
                      <h6>{groupTierData.description}</h6>
                    </li>
                    <li>
                      <h4>Last Updated At</h4>
                      <h6>{groupTierData.last_updated_at}</h6>
                    </li>
                    <li>
                      <h4>Last Updated By</h4>
                      <h6>{groupTierData.last_updated_by}</h6>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-12">
            <div className="card">
              <div className="card-body">
                <div className="slider-prize-details">
                  <h4>Included Tiers</h4>
                  <div className="table-responsive">
                    <table className="table table-hover">
                      <thead>
                        <tr>
                          <th>Tier ID</th>
                          <th>Name</th>
                          <th>Prize</th>
                          <th>Probability %</th>
                        </tr>
                      </thead>
                      <tbody>
                        {tierDetails.map((tier) => (
                          <tr key={tier.tier_id}>
                            <td>{tier.tier_id}</td>
                            <td>{tier.name}</td>
                            <td>{tier.prize_info?.name || "N/A"}</td>
                            <td>{tier.probability_with_rank}%</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GroupTierDetail; 